import React from 'react'

interface ColorPickerFieldProps {
    label: string
    value?: string | null
    onChange: (value: string) => void
    error?: string
    required?: boolean
    placeholder?: string
}

const HEX_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/

const normalizeForPicker = (value?: string | null) => {
    if (!value) return '#000000'
    return HEX_REGEX.test(value) ? value : '#000000'
}

const ColorPickerField: React.FC<ColorPickerFieldProps> = ({
    label,
    value,
    onChange,
    error,
    required = false,
    placeholder = '#RRGGBB',
}) => {
    return (
        <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {label} {required && <span className="text-red-700">*</span>}
            </label>

            <div className="flex items-center gap-3 p-2 border border-gray-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800">
                <input
                    type="color"
                    value={normalizeForPicker(value)}
                    onChange={(e) => onChange(e.target.value)}
                    className="h-10 w-10 p-0 border-0 bg-transparent cursor-pointer"
                />

                <input
                    type="text"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    className="flex-1 px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
            </div>

            {error && <p className="text-xs text-red-600">{error}</p>}
        </div>
    )
}

export default ColorPickerField
